import { render, staticRenderFns } from "./tipsModal.vue?vue&type=template&id=0ff2f610&scoped=true"
import script from "./tipsModal.vue?vue&type=script&lang=js"
export * from "./tipsModal.vue?vue&type=script&lang=js"
import style0 from "./tipsModal.vue?vue&type=style&index=0&id=0ff2f610&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff2f610",
  null
  
)

export default component.exports